import 'ui-core/components/drop-block/js/drop-block';

UX.dropBlock.vPort = 'screen-md';
UX.dropBlock.find.target = function (e) {
    if ($('[data-db-target-of]').length) {
        UX.dropBlock.$targets = $('[data-db-target-of]');
        UX.dropBlock.$target = $('[data-db-target-of=' + UX.dropBlock.$controller.attr('data-db-target-for') + ']');
        UX.dropBlock.$section = UX.dropBlock.$target;
        UX.dropBlock.find.parent();
        UX.dropBlock.on.show(e);
    }
};
